import { render, staticRenderFns } from "./PartitionReviewDialog.vue?vue&type=template&id=47d64171&scoped=true"
import script from "./PartitionReviewDialog.vue?vue&type=script&lang=js"
export * from "./PartitionReviewDialog.vue?vue&type=script&lang=js"
import style0 from "./PartitionReviewDialog.vue?vue&type=style&index=0&id=47d64171&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d64171",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d64171')) {
      api.createRecord('47d64171', component.options)
    } else {
      api.reload('47d64171', component.options)
    }
    module.hot.accept("./PartitionReviewDialog.vue?vue&type=template&id=47d64171&scoped=true", function () {
      api.rerender('47d64171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/PartitionReviewDialog.vue"
export default component.exports